import { redirectToHomeIfBuilderUnavailable } from '@/job-architecture-builder/router/guards';

const JobArchitectureBuilderPage = () => import('@/job-architecture-builder/pages/job-architecture-builder-page.vue');

export const jobArchitectureBuilderRoutes = [
  {
    path: '/job-architecture-builder',
    name: 'job-architecture-builder',
    component: JobArchitectureBuilderPage,
    beforeEnter: redirectToHomeIfBuilderUnavailable,
  },
];
